module.exports = ".example-container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n  }\n  \n  .example-container > * {\n    width: 100%;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/bookShared/enrichmentTabs/enrichmentTabPopups/pagesIndex/pagesIndex.component.css
// module id = ./src/app/bookShared/enrichmentTabs/enrichmentTabPopups/pagesIndex/pagesIndex.component.css
// module chunks = main